import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, DateField } from './util';

@ModelInstance({
  mappingFields: {
    id: 'id',
    camera_id: 'cameraId',
    recording_key: 'recordingKey',
    start_date: 'startDate',
    embed_url: 'embedUrl',
    is_live: 'isLive',
  },
  relation: {
    startDate: DateField,
  }
})
export class Recording extends BaseModel {
  id: number;
  cameraId: number;
  recordingKey: string;
  startDate: Date;
  embedUrl: string;
  isLive: boolean;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
